import {changeTen99Filters, clear1099s, EmptyTen99Filter, getTen99s, FilterEnum} from 'Agent/1099s/ducks/1099';
import {Ten99} from 'Agent/1099s/models/1099';
import {useBreadcrumbs} from 'Core/hooks/useBreadcrumbs';
import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {RouteComponentProps} from 'react-router-dom';
import {ReducerState} from 'rootReducer';
import FileDownloadButton, {FileExtension} from 'Shared/components/FileDownloadButton';
import Column from 'Shared/components/PagedView/Column';
import {withSelectFilterProperties, withStringFilterProperties} from 'Shared/components/PagedView/Filter';
import PagedView from 'Shared/components/PagedView/PagedView';
import {getSourceOptions} from 'Shared/constants/Source';
import {AgencyFilters} from 'Shared/models/AgencyFilters';
import {addFilterParameters} from 'Shared/utilities/addFilterParameters';
import {withValueChanged} from 'Shared/utilities/withValueChanged';

export const get1099FileName = (ten99: Ten99) => `1099_${ten99.accountNumber}_${ten99.taxYear}`;

type Ten99sProps = {
  selectedAgency: AgencyFilters;
} & RouteComponentProps;

const Ten99s = (props: Ten99sProps) => {
  const dispatch = useDispatch();
  useBreadcrumbs("1099's", props.match.url);
  const {selectedAgency} = props;
  const {ten99sFilter, ten99s} = useSelector((state: ReducerState) => state.ten99);
  const agentNumbers = useSelector((state: ReducerState) => state.user.profile.currentAgentNumbers);

  const taxForms: FilterEnum[] = [
    {
      name: 'MISC',
      value: '1',
    },
    {
      name: 'NEC',
      value: '2',
    },
  ];

  useEffect(() => {
    return () => {
      dispatch(clear1099s());
      dispatch(changeTen99Filters(EmptyTen99Filter));
    };
  }, [clear1099s, changeTen99Filters]);

  useEffect(() => {
    dispatch(
      getTen99s(agentNumbers, selectedAgency.encryptedIdentifier, selectedAgency.isNewYork, undefined, ten99sFilter)
    );
  }, [ten99sFilter, selectedAgency, getTen99s]);

  const changeFilter = withValueChanged(ten99sFilter, filter => dispatch(changeTen99Filters(filter)));
  const filterProperties = {
    changeFilter,
    filterData: ten99sFilter,
  };

  return (
    <PagedView
      pagedViewKey="1099"
      loadMore={page => {
        dispatch(
          getTen99s(agentNumbers, selectedAgency.encryptedIdentifier, selectedAgency.isNewYork, page, ten99sFilter)
        );
      }}
      data={ten99s}
    >
      {columnProps => (
        <>
          <Column
            {...columnProps}
            title="Account Number"
            filterProperties={withStringFilterProperties(filterProperties, 'accountNumber')}
            default
          >
            {ten99 => ten99.accountNumber}
          </Column>
          <Column
            {...columnProps}
            title="Account Name"
            filterProperties={withStringFilterProperties(filterProperties, 'accountName')}
            default
          >
            {ten99 => ten99.accountName}
          </Column>
          <Column
            {...columnProps}
            title="History"
            filterProperties={withStringFilterProperties(filterProperties, 'history')}
            default
          >
            {ten99 => ten99.history}
          </Column>
          <Column
            {...columnProps}
            title="Tax Year"
            filterProperties={withStringFilterProperties(filterProperties, 'taxYear')}
            default
          >
            {ten99 => ten99.taxYear}
          </Column>
          <Column
            {...columnProps}
            title="Tax Form"
            filterProperties={withSelectFilterProperties(filterProperties, 'taxFormType', taxForms)}
            default
          >
            {ten99 => ten99.taxFormType?.name}
          </Column>
          <Column
            {...columnProps}
            title="Source"
            filterProperties={withSelectFilterProperties(
              filterProperties,
              'sourceId',
              getSourceOptions(selectedAgency.isNewYork)
            )}
            default
          >
            {ten99 => ten99.source?.name}
          </Column> 

          <Column {...columnProps} title="" isActions default>
            {ten99 => (
              ten99.links![0] != null ?
              <FileDownloadButton
                extension={FileExtension.TIFF}
                downloadedFileName={get1099FileName(ten99)}
                displayTooltip={false}
                relativeFileLocation={
                  ten99.links![0].href! + addFilterParameters({encryptedIdentifier: selectedAgency.encryptedIdentifier})
                }
              >
                Download
              </FileDownloadButton>
               :
               <div>N/A</div>
            )}
          </Column>
        </>
      )}
    </PagedView>
  );
};

export default Ten99s;
